import { Injectable, Injector, OnDestroy } from "@angular/core";
import { ImageViewerService, ViewerItem } from '@mydocma/component-library/src/lib/image-viewer';
import { DailyReportFileModel } from "../../../rp-common/report/report-model";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { TaskFileDownloadService } from "@mydocma/task";
import { ReportSettings } from "../../../rp-common/report-settings/report-settings";

@UntilDestroy()
@Injectable()
export class RpImageViewerService extends ImageViewerService<DailyReportFileModel> implements OnDestroy {

    protected taskDownloadService: TaskFileDownloadService;
    protected reportSettings: ReportSettings;


    constructor(
        protected readonly injector: Injector,
    ) {
        super();
        this.reportSettings = injector.get('ReportSettings');


        this.fullScreen$.pipe(untilDestroyed(this)).subscribe(fs => {
            if (!fs) {
                this.reset();
            }
        });
    }

    ngOnDestroy(): void {
    }

    async showInFullScreen(options: {
        currentItem?: DailyReportFileModel,
        items?: Array<DailyReportFileModel>,
        itemLoader?: (item: DailyReportFileModel) => Promise<ViewerItem>
    }) {

        if (options?.currentItem?.data?.fileName != null && (options.currentItem?.data?.fileName.toLocaleLowerCase()?.includes('pdf'))) {
            this.taskDownloadService = this.injector.get(TaskFileDownloadService);
            const fileUrl = this.reportSettings.apiUrl + '/files/' + options.currentItem.data.fileId + "?originalFileName=true";
            await this.taskDownloadService.downloadFile(fileUrl, {
                open: true,
            });
            return;
        }
        else {
            this.fullScreen = true;
            this.currentItem = options.currentItem;
            this.itemLoader = options.itemLoader;
            this.items = (options.items ? options.items : [options.currentItem]).filter(a => {
                return !a?.data?.fileName?.toLocaleLowerCase()?.includes('pdf');
            });
        }
    }

    private reset() {
        this.currentItem = null;
    }
}

